<template>
  <div
    v-if="socialMedia"
    class="flex flex-row flex-wrap justify-center gap-4"
  >
    <UButton
      v-if="socialMedia.facebook"
      :to="`https://fb.me/${socialMedia.facebook}`"
      target="_blank"
      icon="i-simple-icons:facebook"
      class="!text-facebook"
      :variant="variant"
      :size="size"
      :ui="uiClasses"
      :title="t('comps.actionSocialMedia.btnOpen', { platform: 'Facebook' })"
      @click="onClick('facebook')"
    />

    <UButton
      v-if="socialMedia.facebook"
      :to="`https://m.me/${socialMedia.facebook}`"
      target="_blank"
      icon="i-simple-icons-messenger"
      class="!text-messenger"
      :variant="variant"
      :size="size"
      :ui="uiClasses"
      :title="t('comps.actionSocialMedia.btnOpen', { platform: 'Facebook Messenger' })"
      @click="onClick('messenger')"
    />

    <UButton
      v-if="socialMedia.instagram"
      :to="`https://ig.me/m/${socialMedia.instagram}`"
      target="_blank"
      icon="i-simple-icons:instagram"
      class="!text-instagram"
      :variant="variant"
      :size="size"
      :ui="uiClasses"
      :title="t('comps.actionSocialMedia.btnOpen', { platform: 'Instagram' })"
      @click="onClick('instagram')"
    />
    <UButton
      v-if="socialMedia.tiktok"
      :to="`https://www.tiktok.com/@${socialMedia.tiktok}`"
      target="_blank"
      icon="i-simple-icons:tiktok"
      class="!text-tiktok"
      :variant="variant"
      :size="size"
      :ui="uiClasses"
      :title="t('comps.actionSocialMedia.btnOpen', { platform: 'TikTok' })"
      @click="onClick('tiktok')"
    />
    <UButton
      v-if="socialMedia.youtube"
      :to="`https://www.youtube.com/@${socialMedia.youtube}`"
      target="_blank"
      icon="i-simple-icons:youtube"
      class="!text-youtube"
      :variant="variant"
      :size="size"
      :ui="uiClasses"
      :title="t('comps.actionSocialMedia.btnOpen', { platform: 'YouTube' })"
      @click="onClick('youtube')"
    />
    <UButton
      v-if="socialMedia.linkedin"
      :to="`https://www.linkedin.com/company/${socialMedia.linkedin}/posts`"
      target="_blank"
      icon="i-simple-icons:linkedin"
      class="!text-linkedin"
      :variant="variant"
      :size="size"
      :ui="uiClasses"
      :title="t('comps.actionSocialMedia.btnOpen', { platform: 'LinkedIn' })"
      @click="onClick('linkedin')"
    />
  </div>
</template>

 <!-- TODO: fix this is social media to target companies -->

    <!-- <UButton
      v-if="socialMedia.x"
      :to="`https://x.com/${socialMedia.x}`"
      target="_blank"
      icon="i-simple-icons-x"
      class="!text-black"
      :variant="variant"
      :size="size"
      :ui="uiClasses"
      @click="onClick({
        meta: 'opened_x',
        google: 'opened_x',
        snapchat: undefined,
      })"
    /> -->

    <!-- TODO: fix this is social media to target companies -->

    <!-- <UButton
      v-if="socialMedia.bluesky"
      :to="`https://bsky.app/profile/${socialMedia.bluesky}`"
      target="_blank"
      icon="i-simple-icons-x"
      class="!text-black"
      :variant="variant"
      :size="size"
      :ui="uiClasses"
      @click="onClick({
        meta: 'opened_bluesky',
        google: 'opened_bluesky',
        snapchat: undefined,
      })"
    /> -->

 <!-- TODO: fix this is social media to target companies -->

<script setup lang="ts">
defineProps({
  socialMedia: {
    type: Object,
    required: true,
    // default: null,
  },
  size: {
    // as PropType<ButtonVariants['size']>
    type: String as PropType<'xs' | 'sm' | 'md' | 'lg' | 'xl'>,
    required: false,
    default: 'xl',
  },
})

const { event } = useTracker()

const emit = defineEmits(['btnClick'])

function onClick(platform: string) {
  const event_name = `opened_${platform}`
  event({
    meta: event_name,
    google: event_name,
    // snapchat: undefined,
  })
  emit('btnClick', platform)
}

const variant = 'link'

const uiClasses = {
  base: 'focus:outline-none focus-visible:outline-0 hover:opacity-80 transition flex-shrink-0',
}
</script>
